/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  margin: calc(13rem /14) 0;
  cursor: pointer;
}
:host .cb_box {
  height: calc(24rem /14);
  width: calc(24rem /14);
  border: 1px solid var(--davinci-color-outline,#8E989D);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
}
:host .cb_box svg {
  display: none;
  width: calc(22rem /14);
  height: calc(22rem /14);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .cb_box,
:host .cb_label {
  display: inline-block;
  vertical-align: middle;
}
:host .cb_box {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .cb_label {
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: calc(24rem /14);
  padding-left: calc(8rem /14);
}
:host .cb_label ::slotted(*) {
  line-height: calc(24rem /14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .cb_label.empty {
  display: none;
}

:host .wrapper {
  display: flex;
  flex-direction: row;
}
:host .wrapper .cb_box {
  flex: 0 0 auto;
}
:host .wrapper .cb_label {
  flex: 1 1 auto;
}

:host([checked]) .cb_box svg {
  display: block;
}

:host(:hover) .cb_box,
:host(:focus) .cb_box {
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .cb_label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .cb_label ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .cb_box {
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .cb_box svg {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}

:host(:empty) .cb_label {
  display: none;
}

:host([error]:hover) .cb_box,
:host([error]:focus) .cb_box,
:host([error]) .cb_box {
  border-color: #EA0823;
  border-color: var(--davinci-color-error, #EA0823);
}
:host([error]:hover) .cb_box svg,
:host([error]:focus) .cb_box svg,
:host([error]) .cb_box svg {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}

:host(:focus) {
  outline: none;
}

:host([hidden]) {
  display: none;
}`;
export { style };
